/**
 * Created by Karol Kluska on 26.06.17.
 */

angular
  .module('app')
  .component('modalRateplanAvailability', {
    templateUrl: 'app/shared/modalRateplanAvailability/ModalRateplanAvailability.html',
    controller: ModalRateplanAvailability,
    bindings: {
      resolve: '<',
      close: '&'
    }
  });

function ModalRateplanAvailability($rootScope, Params, Currency, $translate) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.Params = Params;
  $this.Currency = Currency;
  $this.$translate = $translate;
}

ModalRateplanAvailability.prototype = {
  $onInit: function () {
    this.from = this.resolve.from || moment(this.Params.getCheckIn()).format('YYYY-MM-DD');
    this.monthsLength = this.resolve.monthsLength || 1;
    this.calendarsInRow = this.resolve.calendarsInRow || 1;
    this.currencyPrefix = this.Currency.getCurrencyPrefix();
    this.currencySuffix = this.Currency.getCurrencySuffix();
    this.groupId = this.resolve.groupId;
    this.rateplanId = this.resolve.rateplanId || null;
    this.personsCount = this.resolve.personsCount || null;
  },

  handleClose: function () {
    this.close();
  },

  startLoading: function () {
    var $this = this;
    $this.$rootScope.$emit('startLoading', {
      title: $this.$translate.instant('loader.PLEASE_WAIT'),
      description: $this.$translate.instant('loader.AVAILABILITY')
    });
  },

  finishLoading: function () {
    this.$rootScope.$emit('stopLoading');
  }
};
